module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p31",
      "title": "31"
    }
  }, [_c('p', {
    staticClass: "icon"
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v("[")]), _vm._v(" QUICK PREP "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("]")])]), _vm._v(" "), _c('h2', {
    staticClass: "recipetitle",
    attrs: {
      "id": "make_it_your_own_oatmeal"
    }
  }, [_vm._v("Make-It-Your-Own Oatmeal")]), _vm._v(" "), _c('p', {
    staticClass: "recipetime"
  }, [_c('span', {
    staticClass: "yield_black"
  }, [_vm._v("1 serving")]), _vm._v(" "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Prep Time: 5 Minutes "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Start to Finish: 8 Hours 5 Minutes")]), _vm._v(" "), _c('p', {
    staticClass: "dot"
  }, [_vm._v("•••")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient_head"
  }, [_vm._v("OATMEAL")]), _vm._v(" "), _c('ul', {
    staticClass: "ingredient1"
  }, [_c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" container (5.3 oz) 100-calorie fat-free Greek yogurt (any flavor)")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¼")]), _vm._v(" cup old-fashioned or quick-cooking oats")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" teaspoon chia seed")])]), _vm._v(" "), _c('p', {
    staticClass: "ingredient_head"
  }, [_vm._v("STIR-INS (SEE BELOW)")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("1")]), _vm._v(" In container with tight-fitting cover, mix yogurt, oats and chia seed. Add desired stir-ins.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("2")]), _vm._v(" Cover; refrigerate at least 8 hours but no longer than 3 days.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_info"
  }, [_c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("1 Serving:")]), _vm._v(" Calories 190; Total Fat 2g (Saturated Fat 0g, Trans Fat 0g); Cholesterol 0mg; Sodium 45mg; Total Carbohydrate 29g (Dietary Fiber 3g); Protein 13g "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Exchanges:")]), _vm._v(" ½ Starch, 1 Other Carbohydrate, ½ Skim Milk, 1 Very Lean Meat "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Carbohydrate Choices:")]), _vm._v(" 2")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_variation"
  }, [_c('span', {
    staticClass: "variation_lead"
  }, [_vm._v("Almond Oatmeal:")]), _vm._v(" Stir in ¼ cup toasted almonds. Calories 330 (Calories from Fat 120); Total Fat 13g (Saturated Fat 1g, Trans Fat 0g); Cholesterol 0mg; Sodium 55mg; Potassium 240mg; Total Carbohydrate 31g (Dietary Fiber 6g); Protein 21g")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_variation"
  }, [_c('span', {
    staticClass: "variation_lead"
  }, [_vm._v("Banana Oatmeal:")]), _vm._v(" Stir in ¼ cup banana slices. Calories 220 (Calories from Fat 20); Total Fat 2g (Saturated Fat 0g, Trans Fat 0g); Cholesterol 0mg; Sodium 55mg; Potassium 210mg; Total Carbohydrate 34g (Dietary Fiber 4g); Protein 16g")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_variation"
  }, [_c('span', {
    staticClass: "variation_lead"
  }, [_vm._v("Blackberry Oatmeal:")]), _vm._v(" Stir in ¼ cup blackberries. Calories 200 (Calories from Fat 20); Total Fat 2.5g (Saturated Fat 0g, Trans Fat 0g); Cholesterol 0mg; Sodium 55mg; Potassium 135mg; Total Carbohydrate 29g (Dietary Fiber 5g); Protein 16g")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_variation"
  }, [_c('span', {
    staticClass: "variation_lead"
  }, [_vm._v("Blueberry Oatmeal:")]), _vm._v(" Stir in ¼ cup blueberries. Calories 210 (Calories from Fat 20); Total Fat 2g (Saturated Fat 0g, Trans Fat 0g); Cholesterol 0mg; Sodium 55mg; Potassium 105mg; Total Carbohydrate 31g (Dietary Fiber 4g); Protein 16g")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_variation"
  }, [_c('span', {
    staticClass: "variation_lead"
  }, [_vm._v("Honey Oatmeal:")]), _vm._v(" Stir in 1 tablespoon honey or 2 tablespoons comb honey.* Calories 260 (Calories from Fat 20); Total Fat 2g (Saturated Fat 0g, Trans Fat 0g); Cholesterol 0mg; Sodium 60mg; Potassium 90mg; Total Carbohydrate 43g (Dietary Fiber 3g); Protein 16g")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_variation"
  }, [_c('span', {
    staticClass: "variation_lead"
  }, [_vm._v("Pomegranate Oatmeal:")]), _vm._v(" Stir in ¼ cup pomegranate seeds. Calories 230 (Calories from Fat 25); Total Fat 2.5g (Saturated Fat 0g, Trans Fat 0g); Cholesterol 0mg; Sodium 60mg; Potassium 180mg; Total Carbohydrate 34g (Dietary Fiber 4g); Protein 16g")]), _vm._v(" "), _c('p', {
    staticClass: "recipefootnote"
  }, [_vm._v("*Those with bee sting allergies should consult their physician before consuming comb honey.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99c36b00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/p031.vue
// module id = 138
// module chunks = 0